import { getDateSortValue } from './dates.js';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const isDeadStatus = (status) => String(status || '').trim().toLowerCase() === 'dead';

// Career length runs from First Adventure to today, unless the character is
// Dead, in which case it freezes at Deathday (falling back to today if no
// Deathday was recorded).
export const getCareerLengthDays = (character) => {
  const startMs = getDateSortValue(character?.first_adventure);
  if (!startMs) return null;

  const deathMs = isDeadStatus(character?.status) ? getDateSortValue(character?.deathday) : 0;
  const endMs = deathMs || Date.now();

  const days = Math.round((endMs - startMs) / MS_PER_DAY);
  return days >= 0 ? days : null;
};

export const formatCareerLength = (totalDays) => {
  if (!Number.isFinite(totalDays)) return '';
  const years = Math.floor(totalDays / 365);
  const afterYears = totalDays - years * 365;
  const months = Math.floor(afterYears / 30);
  const days = Math.round(afterYears - months * 30);

  const parts = [];
  if (years) parts.push(`${years} yr${years === 1 ? '' : 's'}`);
  if (months) parts.push(`${months} mo`);
  if (!years && !months) parts.push(`${days} day${days === 1 ? '' : 's'}`);
  return parts.join(', ') || '0 days';
};
